<template>
  <form class="search-filter">
    <div class="search-filter__box" :style="boxStyle">
      <div class="search-filter__scroll-container">
        <ul class="search-filter__ul">
          <li class="search-filter__li">
            <!-- Token -->
            <div class="token font-12 font-12--light">

              <template v-for="(token, indexToken) in tokens">
                <template v-for="(level, index) in token">
                  <div class="token__level" :key="`${level}-${indexToken}-${index}`" v-if="!level.resultObjectOnly">
                    {{ level.label }}
                  </div>
                </template>
                <div class="token__remove" @click="remove(indexToken)" v-if="mappedFilters[indexToken] && tokens[indexToken].length - 1 >= mappedFilters[indexToken].options.length"><i class='bx bx-x'></i></div>
              </template>

            </div>
          </li>

          {{ /* sample to check styling */ }}
          <!--
          <li class="search-filter__li" v-if="isTokens">
              <div class="token font-12 font-12--light">
                  <div class="token__level">Date</div>
                  <div class="token__container">
                      <div class="token__value" data-id="@fanny">
                          File Open
                      </div>
                      <div class="token__remove" @click="remove"><i class='bx bx-x'></i></div>
                  </div>
              </div>
          </li>
          -->

          <!-- input with drop down-->
          <li class="search-filter__li search-filter__li--input">
            <div class="dropdown">
              <date-range-picker
                  v-show="showDateRange"
                  ref="picker"
                  opens="left"
                  class="font-12"
                  :ranges="predefinedTimeRanges"
                  :locale-data="localeData"
                  :close-on-esc="true"
                  @update="handleDateUpdate"
                  @toggle="handleDateToggle"
                  v-model="dateRange"
              />
              <b-form-input v-show="!showDateRange"
                            class="search-filter__input font-12"
                            ref="search-filter-input"
                            id="search-filter-input"
                            v-model="search"
                            type="text"
                            @focus="showDropdown"
                            @click="showDropdown"
                            @keyup.delete="keyDownBackspace"
                            debounce="100"
                            @change="changeEvent"
                            @input="changeEvent"
                            aria-haspopup="true"
                            aria-expanded="false"
                            autocomplete="off"
                            data-toggle="dropdown"
                            :placeholder="computedPlaceholder"
              >

              </b-form-input>

              <div ref="dropdown"
                   class="dropdown-menu search-filter__dropdown-menu"
                   aria-labelledby="search-filter-input"
                   v-if="!isDateFilter && filteredFilters.length && !tokenComplete">
                <template v-for="(filter, index) in filteredFilters">
                  <a class="dropdown-item search-filter__dropdown-item font-12"
                     ref="filters"
                     @focus="showDropdown"
                     @keydown="handleKeydownDropdown"
                     href="#"
                     :key="filter.label.toLowerCase()"
                     @click.prevent.stop="selectFilter(index)">
                    <i class='bx' :class="filter.iconClass"></i>
                    <span>{{ filter.label }}</span>
                  </a>
                </template>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div ref="overlay" class="overlay" @click="hideDropdown"></div>
    </div>
    <div class="rs-button-container"></div>

    <div v-if="debug" class="debug">
      <div class="debug__title">Search-Filter Debug:</div>
      <div class="debug__item"><span class="debug__key">tokenComplete:</span><span class="debug__value">{{ tokenComplete }}</span></div>
      <div class="debug__item"><span class="debug__key">dropdownPosition:</span><span class="debug__value">{{ dropdownPosition }}</span></div>
      <div class="debug__item"><span class="debug__key">filterResult:</span><span class="debug__value">{{filterResult || 'Empty'}}</span></div>
      <div class="debug__item"><span class="debug__key">filterResultObj:</span><span class="debug__value">{{filterResultObj || 'Empty'}}</span></div>
    </div>
  </form>
</template>

<script>
import Filter from './Filter';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
import _ from 'lodash';

export { Filter }

export default {
  props: {
    optionsLength: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'empty' // | 'cards' | 'activities' | --take a look in Filter.vue file for other options
    },
    value: {
      type: String || Object,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search or Filter results'
    },
    height: {
      type: String,
      default: '39px'
    },
    filters: {
      type: Array,
      default: () => []
    },
    debug: {
      type: Boolean,
      default: false,
    },
    filterValue: {
      type: String,
      default: '',
    }
  },
  components: {
    DateRangePicker
  },
  data() {
    let startDate = new Date();
    let endDate = new Date();
    endDate.setDate(endDate.getDate() + 6)


    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let last7Days = new Date();
    last7Days.setDate(last7Days.getDate() - 6);
    let last14Days = new Date();
    last14Days.setDate(last14Days.getDate() - 13);


    let yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)
    yesterday.setHours(0, 0, 0, 0);

    let date = new Date();
    date.setHours(0, 0, 0, 0);
    const thisMonthStart = new Date(date.getFullYear(), date.getMonth(), 1);
    const thisMonthEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    return {
      dateRange: {startDate, endDate},
      isTokens: true,
      selectedCategory: -1,
      selectedCategoryLabel: '',
      token: [],
      tokens: {
        0: [],
        1: [],
        2: [],
      },
      selectedCategories: [],
      isCanOpenDropdown: true,
      search: '',
      dropdownPosition: 0,
      dropdown: {},
      localeData: {
        format: 'ddd, mmm dd, yyyy'
      },
      selectedTokenIndex: 0,
      predefinedTimeRanges: {
        'Today': [today, today],
        'Yesterday': [yesterday, yesterday],
        'Last 7 Days': [last7Days, startDate],
        'Last 14 Days': [last14Days, startDate],
        'This month': [thisMonthStart, thisMonthEnd],
        'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
        'Custom Range': [today, today],
      },
      showDateRange: false,
    };
  },
  computed: {
    computedCurrentToken() {
      return this.tokens[this.selectedTokenIndex];
    },
    computedPlaceholder() {
      return this.tokens.length ? '' : this.placeholder;
    },
    currentLevel() {
      return this.computedCurrentToken.length - 1;
    },
    maxLength() {
      if (this.selectedCategory >= 0) {
        // console.log('this.mappedFilters[this.selectedCategory]', this.mappedFilters[this.selectedCategory]);
        return this.mappedFilters[this.selectedCategory].options.length;
      } else {
        return null;
      }
    },
    // add original index for search filter feature
    mappedFilters() {
      return this.filters.map((filter, index) => {
        filter.originalIndex = index;
        return filter;
      })
    },
    filteredFilters() {
      if (this.tokens.length === 0 || (this.tokens && this.tokens[this.selectedTokenIndex] && this.tokens[this.selectedTokenIndex].length === 0)) {
        // console.log('filtered filter -- CATEGORY')
        return this.mappedFilters.filter(filter => {
          const label = filter.label.toLowerCase();
          const searchWord = this.search.trim().toLowerCase();
          return label.includes(searchWord) && !this.selectedCategories.includes(filter.label);
        });
      } else if (this.tokens && this.tokens[this.selectedTokenIndex] && this.tokens[this.selectedTokenIndex].length > 0
          && this.mappedFilters[this.selectedCategory] && this.mappedFilters[this.selectedCategory].options[this.computedCurrentToken.length - 1]) {
        // console.log('filtered filter -- OPTIONS')
        return this.mappedFilters[this.selectedCategory].options[this.computedCurrentToken.length - 1].filter(filter => {
          if (filter.label !== null && filter.label) {
            const label = filter.label.toLowerCase();
            const searchWord = this.search.trim().toLowerCase();
            return label.includes(searchWord);
          }
        });
      } else {
        this.selectedTokenIndex +=1;
        return this.mappedFilters.filter(filter => {
          return !this.selectedCategories.includes(filter.label);
        });
      }
    },
    isDateFilter() {
      return false;
      // return this.filteredFilters[0] && this.filteredFilters[0].type && this.filteredFilters[0].type === 'Date';
    },
    tokenComplete() {
      return  false;
      return this.currentLevel >= this.maxLength;
    },
    filterResultObj() {
      let result = {};

      let key = this.selectedTokenIndex;

      _.forEach(this.mappedFilters, (filter) => {
        result[filter.originalIndex] = {
          search: this.search,
        }
        if (this.tokens[filter.originalIndex] && this.tokens[filter.originalIndex].length > 0) {
          this.tokens[filter.originalIndex].forEach((token, index) => {
            const id = token.id
            // category always even or 0 -- due to nature of array
            if (index === 0 || index % 2 === 0) {
              result[filter.originalIndex] [id] = ''

              // value always odd
            } else if (token.type === 'Date') {
              result[filter.originalIndex][this.tokens[filter.originalIndex][index - 1].id] = token;
            } else {
              result[filter.originalIndex][this.tokens[filter.originalIndex][index - 1].id] = token.label;
            }
          })
        }
      });
      return result;
    },
    filterResult() {
      let res = '';
      if (this.computedCurrentToken && this.computedCurrentToken.length === 0) {
        res = '';
      } else if (this.computedCurrentToken && this.computedCurrentToken.length > 0) {
        this.computedCurrentToken.forEach((token, index) => {
          // only output string
          if (token.resultObjectOnly || (index > 0 && this.computedCurrentToken[index - 1] && this.computedCurrentToken[index - 1].resultObjectOnly)) return;

          // ignore first token, it is category for example, 'Rego', 'Vehicle Owner'
          if (index === 0) {
            res = '';
          }
          else if (index === 1) {
            res = token.label ? token.label : res;
          }
          else if (index > 1) {
            res = token.label ? res.trim() + ' ' + token.label : res;
          }
        });
      }
      res += ' ' + this.search;
      res = res.trim();
      // console.log('token.length', this.token.length, res);
      return res;
    },
    boxStyle() {
      return {
        'height': this.height
      }
    }
  },
  watch: {
    filterValue(val) {
      this.search = val;
    },
    filterResult(val) {
      // this.$emit('input', val);
    },
    // filterResultObj: {
    //   deep: true,
    //   handler(newVal) {
    //     this.$emit('change', newVal)
    //   }
    // },
  },
  mounted() {
    this.dropdown = $(this.$refs['search-filter-input']);

    // additional external listener
    // these element are not covered by overlay

    if (document.querySelector('.site-header')) {
      document.querySelector('.site-header').addEventListener('click', this.hideDropdown)
    }

    if (document.querySelector('.page-header')) {
      document.querySelector('.page-header').addEventListener('click', this.hideDropdown)
    }



    // this.mappedFilters = Filter.generate(this.type);
  },
  unmounted() {
    document.querySelector('.site-header').removeEventListener('click', this.hideDropdown);
    document.querySelector('.page-header').removeEventListener('click', this.hideDropdown);
  },
  filters: {
    formatDate(val) {
      return moment(val).format('ddd, MMM DD, YYYY')
    }
  },
  methods: {
    changeEvent() {
      // let interval = setInterval(() => {
      //   console.log(this.filterResultObj, 'filterResultOBj')
      //   if (!_.isEmpty(this.filterResultObj)) {
      //     this.$emit('change', this.filterResultObj);
      //     clearInterval(interval);
      //   }
      // }, 10);
      this.$emit('change', this.filterResultObj);
    },
    showDropdown() {
      if (!this.isCanOpenDropdown) {
        return;
      }
      $(this.$refs.dropdown).dropdown().toggle(true);
      $(this.$refs.overlay).show();
    },
    hideDropdown() {
      $(this.$refs.dropdown).dropdown().toggle(false);
      $(this.$refs.overlay).hide();
    },
    remove(indexToken) {
      if (indexToken >= this.optionsLength) {
        this.selectedTokenIndex = this.optionsLength - 1;
        indexToken = this.selectedTokenIndex;
      }
      if (this.tokens[indexToken] && this.tokens[indexToken][0]) {
        let categoryName = this.tokens[indexToken][0].label;
        let index = this.selectedCategories.indexOf(categoryName);
        if (index !== -1) {
          this.selectedCategories.splice(index, 1);
        }
      }

      this.tokens[indexToken] = [];
      if (indexToken <= 0) {
        _.forEach(this.tokens, (token, index) => {
          this.tokens[index] = [];
        })
        this.selectedTokenIndex = 0;
      }
      _.forEach(this.tokens, (token, index) => {
        if (index > indexToken) {
          this.tokens[index] = [];
        }
      })

      this.isCanOpenDropdown = true;
      if (this.selectedTokenIndex !== 0) {
        this.selectedTokenIndex-=1;
      }
      this.search = '';

      this.selectedCategory = -1;
      this.dropdownPosition = 0;
      this.showDateRange = false;
      this.changeEvent();
    },
    selectFilter(index) {

      if (this.tokens[this.selectedTokenIndex].length === 0) {
        // select category
        this.selectCategory(index)
      } else {
        // do nothing, and continue
        // select a non-category filter will be calculated in filtered filters
      }

      // selecting a date
      if (this.filteredFilters[index].label === 'Date') {
        this.showDateRange = true;
        this.$nextTick(() => {
          this.$refs.picker.togglePicker(true);
        });
      }
      console.log('index', index)
      // hide dropdown when a token complete
      this.$nextTick(() => {
        // if complete hide dropdown
        //token complete

        //     if (this.mappedFilters[index] && this.tokens[this.selectedTokenIndex].length - 1 >= this.mappedFilters[index].options.length) {
        if (this.tokens[this.selectedTokenIndex].length === 2) {
          // this.selectedTokenIndex++;
          if (this.selectedTokenIndex + 1 === this.optionsLength) {
            this.isCanOpenDropdown = false;
          } else {
            this.selectedTokenIndex+=1;
          }
          this.selectedCategories.push(this.selectedCategoryLabel);
          this.changeEvent();
          this.hideDropdown();
        }
      });

      this.tokens[this.selectedTokenIndex].push(this.filteredFilters[index]);
      this.resetSearchInput();
    },
    selectCategory(index) {
      this.selectedCategoryLabel = this.filteredFilters[index].label;
      this.selectedCategory = this.filteredFilters[index].originalIndex;
    },
    resetSearchInput() {
      this.search = '';
      this.dropdownPosition = 0;
      const searchInput = this.$refs['search-filter-input'];
      this.$nextTick(() => {
        if (searchInput) {
          searchInput.focus();
        }
      })
    },
    // Search Input Keydown
    keyDownBackspace() {
      if (!this.search.length) {
        // if (this.selectedTokenIndex !== 0) {
        //   this.selectedTokenIndex -= 1;
        // }
        this.selectedTokenIndex -= 1;
        this.remove(this.selectedTokenIndex);
        // this.selectedTokenIndex = this.optionsLength - 1;
        // if (this.selectedTokenIndex >= this.optionsLength) {
        //   this.remove(this.selectedTokenIndex);
        // } else {
        //   this.remove(this.selectedTokenIndex - 1);
        // }

      }
    },

        // Search Input Keyup
    // handle keys on dropdown
    handleKeydownDropdown(e) {
      e.preventDefault();
      switch(e.keyCode) {
        case 38: // up
        {
          this.dropdownPosition --;
          if (this.dropdownPosition > -1) {
            this.$refs['filters'][this.dropdownPosition].focus();
          } else {
            // focus to input
            this.dropdownPosition = 0;
            this.$refs['search-filter-input'].focus();
            this.showDropdown();
          }
          break;
        }
        case 40: // down
        {
          this.dropdownPosition ++;
          if (this.dropdownPosition < this.$refs['filters'].length) {
            console.log('')
          } else {
            this.dropdownPosition = 0;
          }
          this.$refs['filters'][this.dropdownPosition].focus();
          break;
        }
        case 32: // space
        case 13: // enter
        {
          this.selectFilter(this.dropdownPosition);
          this.dropdownPosition = 0;
          break;
        }
        case 8: // delete
        case 27: // esc
        default:
        {
          if (e.key.length === 1) {
            this.search += e.key;
          }
          this.showDropdown();
          this.dropdownPosition = 0;
          this.$refs['search-filter-input'].focus();
        }
      }
    },
    handleDateUpdate() {
      const obj = this.dateRange;
      obj.type = 'Date';
      obj.label = `${moment(this.dateRange.startDate).format('ddd, MMM DD, YYYY')} - ${moment(this.dateRange.endDate).format('ddd, MMM DD, YYYY')}`
      // this.token.pop();

      this.token.push(this.dateRange);

      // focus on next input
      this.$nextTick(() => {
        this.resetSearchInput();
      });
    },
    handleDateToggle(show) {
      // console.log('handleDateToggle', arguments);
      // console.log('this.isDateFilter', this.isDateFilter);
      // console.log('this.currentLevel', this.currentLevel);
      if (!show) {
        this.showDateRange = false;
        this.$nextTick(() => {
          // console.log('this.currentLevel', this.currentLevel);

          if (this.token[this.currentLevel].startDate) {
            return;
          } else {
            const lastFilter = this.token.pop();
            console.log('lastFilter', lastFilter)
            // this.search = lastFilter.label.slice(0, -1);
            this.search = '';

            this.$nextTick(() => {
              const searchInput = this.$refs['search-filter-input'];
              if (searchInput) {
                searchInput.focus();
              }
            })
          }
        });
      }
    }
  }
}
</script>

<style scoped>
ul {
  margin: 0;
  padding: 0;
}

.font-12 {
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  letter-spacing: normal;
  letter-spacing: 0;
  color: #1C1F39;
}

.search-filter__box {
  display: flex;
  align-items: center;
  position: relative;
  /* background-color: turquoise; */

  box-sizing: border-box;
  padding-left: 5.5px;

  height: 39px;
  border: 1px solid rgba(28, 31, 57, 0.25);
  border-radius: 3px;

  z-index: 10;
}

.search-filter__scroll-container {
  width: 100%;
}

.search-filter__ul {
  margin: 0;
  padding: 0;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  /* justify-content: center; */
}

.search-filter__li {
  display: inline-block;
  position: relative;
  margin-right: 5.5px;
}

.search-filter__li:hover {
  /* reset */
  border-bottom-color: transparent !important;
}

.search-filter__li > * {
  display: inline-block;
}

.search-filter__li--input {
  flex: 1 1 100%;
}

.search-filter__input {
  position: relative;
  /* border-color: 0; */
  box-sizing: border-box;
  width: 100%;
  box-shadow: none !important;
  border-color: transparent !important;
  margin: 0;
  height: 16px;
  width: 140px;
  padding: 0;
}
.search-filter__input::placeholder {
  color: #1C1F39;
  opacity: 0.5;
}
.search-filter__input--no-placeholder::placeholder {
  display: none;
}

/* Dropdown */
/* Dropdown Container */
.search-filter__dropdown {

}
/* Dropdown Container */
.dropdown-menu.search-filter__dropdown-menu {
  margin-top: 19px;
  padding-top: 7px;
  padding-bottom: 7px;
  border-color: white;
  box-shadow: 0 2px 20px 0 rgba(0,0,0,0.1);
  border-radius: 3px;

  max-height: 275px;
  overflow-y: scroll;
}

/* Dropdown Item */
.dropdown-item.search-filter__dropdown-item {
  display: flex;
  align-items: center;
  padding: 7px 15px;
  border-radius: 2px;
}
.dropdown-item.search-filter__dropdown-item .bx {
  margin-right: 7px;
  font-size: 18px;
}
.dropdown-item.search-filter__dropdown-item span {
  position: relative;
  top: 2px;
}


.token {
  display: flex;
  justify-content: center;
}
.token > * {
  margin-right: 2px;
  padding: 6px 5px;
  background-color: rgba(22,25,50,0.05);
  border-radius: 2px;
}
.token div:last-child {
  margin-right: 0;
}

.token__value,
.token__category,
.token__level {
  white-space: nowrap;
}

.token__container {
  display: flex;
}
.token__remove .bx {
  vertical-align: middle;
  font-size: 18px;
}
.token__remove:hover {
  cursor: pointer;
}


/* daterangepicker */
::v-deep .vue-daterange-picker i.glyphicon {
  display: none !important;
}

::v-deep .reportrange-text {
  height: auto;
  margin-right: 5px;
  color:  #8E909C;
  font-weight: normal;
  padding: 10px 30px 5px 5px;
  position: relative;
  top: 1px;
  border: 0;
  height: 31px;
}
::v-deep .reportrange-text span {
  /* color: transparent; */
}
::v-deep .daterangepicker {
  margin-top: 20px;
}
::v-deep .calendars {
  display: flex;
  flex-flow: row-reverse;
}

/* daterangepicker re-styled to design */
::v-deep .vue-daterange-picker .dropdown-menu {
  border: 0;
  box-shadow: 0 2px 20px 0 rgba(0,0,0,0.1);
  border-radius: 3px;
  overflow: hidden;
}

::v-deep div.drp-calendar,
::v-deep div.calendar-table {
  padding: 0 !important;
}

/* calendar head -- month selector */
::v-deep div.calendar-table thead tr th {
  background-color: #00b050 !important;
  border-color: #00b050 !important;
  color: #FFFFFF;
  font-weight: normal;
  min-height: 36px;
}
/* calendar head -- height */
::v-deep div.daterangepicker .calendar-table table tr {
  height: 30px;
}
/* arrow */
::v-deep .daterangepicker .calendar-table .next span,
::v-deep .daterangepicker .calendar-table .prev span {
  border-color: #FFFFFF;
}

/* day names */
::v-deep div.drp-calendar tbody tr:nth-child(1) th {
  color: #00b050;
  font-weight: normal;
}
/* selected days */
::v-deep div.calendar-table {
  border: 0 !important;
}

/* hovered arrow */
::v-deep .daterangepicker td.available:hover,
::v-deep .daterangepicker th.available:hover {
  background-color: #4662ef;
}

::v-deep .daterangepicker td.active,
::v-deep .daterangepicker td.active:hover {
  background-color: #00b050 !important;
  color: #e9fff3 !important;
}

::v-deep .daterangepicker td.off.in-range {
  /* background-color: #ebf4f8;
  border-color: transparent; */
}

::v-deep .daterangepicker td.in-range {
  background-color: rgba(255,127,46,0.1);
  color: #00b050;
  font-weight: bold;
}

::v-deep .daterangepicker td.off.start-date,
::v-deep .daterangepicker td.off.end-date {
  color: #ffffff;
}

::v-deep .daterangepicker td.off.end-date.in-range.active {
  color: #00b050;
}

/* in range days */
::v-deep .daterangepicker td.in-range {
  /* background-color: #e5e9ff !important; */
}

/* date box size */
::v-deep .daterangepicker .calendar-table td,
::v-deep .daterangepicker .calendar-table th {
  min-width: 24px;
  width: 24px;
  height: 24px;
  /* padding: 0; */
}

/* predefined */
::v-deep .daterangepicker.show-calendar .ranges {
  margin-top: 0;
}

::v-deep .daterangepicker .ranges ul {
  width: 120px;
}

::v-deep div.daterangepicker div.ranges li {
  color: #1C1F39;
  font-family: "Nunito Sans";
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 15px;

  background-color: transparent;
  border-color: rgba(28, 31, 57, 0.1);;
  border-radius: 3px;
  margin: 4.5px;
  margin-bottom: 8px;

  height: 28px;
}

::v-deep .daterangepicker .ranges li:hover {
  background-color: rgba(255,127,46,0.1);
  color: #00b050;
}

::v-deep div.daterangepicker div.ranges li.active {
  background-color: #00b050;
  color: #e9fff3;
  border-radius: 3px;
}

/* container size */
::v-deep div.daterangepicker.show-ranges {
  min-width: auto;
}

/* buttons */
::v-deep div.daterangepicker .drp-buttons {
  border-top: 0;
  padding-right: 4.5px;
  padding-left: 4.5px;
  display: flex !important;
}
::v-deep div.daterangepicker .drp-buttons .btn {
  margin-left: 6px;
  font-weight: normal;
  font-size: 11px;
  letter-spacing: normal;
  min-width: 52px;
}

::v-deep div.daterangepicker .drp-buttons .applyBtn {
  border-radius: 3px;
  height: 28px;
  background-color: #00b050;
}
/* make cancel button to right */
::v-deep div.daterangepicker .drp-buttons .cancelBtn {
  float: right;
}

/* calendar width individual */
::v-deep div.daterangepicker .drp-calendar {
  max-width: 215px;
}

/* date label below calendar */
::v-deep div.daterangepicker .drp-selected {
  background: rgba(27,30,56,0.05);
  border-top: 1px solid rgba(27,30,56,0.1);
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* end daterangepicker re-styled */

.overlay {
  position: fixed;
  display: none;
  width: 100vw;
  height: 100vh;
  /* background: aquamarine; */
  opacity: .3;
  top: 0;
  left: 0;
  z-index: -1;
}

.search-filter {
  position: relative;
}

.search-filter__box::after {
  content: '';
  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSIxOHB4IiB2aWV3Qm94PSIwIDAgMTggMTgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA2MiAoMTAxMDEwKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT4wNjRFQjU4Ni05NzJDLTRBMzktQjgwMy0zRUJDNTg1OEI0OTY8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGcgaWQ9IlVJLURlc2lnbiIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgb3BhY2l0eT0iMC41Ij4KICAgICAgICA8ZyBpZD0iRGFzaGJvYXJkLVJlZGVzaWduLShWaWV3LUFzc2Vzb3JzKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyNTIuMDAwMDAwLCAtMTU4LjAwMDAwMCkiIGZpbGw9IiMyNzJBNDMiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxnIGlkPSJUb3AiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1MC4wMDAwMDAsIDYxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTExIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4NDAuMDAwMDAwLCA4Ny4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0ic2VhcmNoIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjIuMDAwMDAwLCAxMC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTguMSwxMy41IEMxMC4wMjkyMzQyLDEzLjUgMTEuODExOTIwMSwxMi40NzA3NjU4IDEyLjc3NjUzNzIsMTAuOCBDMTMuNzQxMTU0NCw5LjEyOTIzNDIgMTMuNzQxMTU0NCw3LjA3MDc2NTggMTIuNzc2NTM3Miw1LjM5OTk5OTk4IEMxMS44MTE5MjAxLDMuNzI5MjM0MTUgMTAuMDI5MjM0MiwyLjcgOC4xLDIuNyBDNS4xMTc2NjIzOCwyLjcgMi43MDAwMDAwOCw1LjExNzY2MjM4IDIuNzAwMDAwMDgsOC4xIEMyLjcwMDAwMDA4LDExLjA4MjMzNzYgNS4xMTc2NjIzOCwxMy41IDguMSwxMy41IFogTTEzLjc4OCwxMi41MTU0IEwxNy4wMSwxNS43Mzc0IEMxNy4yNDM3OTU2LDE1Ljk2MzUzMzYgMTcuMzM3Mzg1MSwxNi4yOTgyMjAzIDE3LjI1NDc5OCwxNi42MTI4MjUxIEMxNy4xNzIyMTA4LDE2LjkyNzQyOTkgMTYuOTI2Mjk5MywxNy4xNzI5OTM5IDE2LjYxMTU3OCwxNy4yNTUxMzYgQzE2LjI5Njg1NjcsMTcuMzM3Mjc4IDE1Ljk2MjMwMjcsMTcuMjQzMjE1MiAxNS43MzY1LDE3LjAwOTEgTDEyLjUxNDUsMTMuNzg3MSBDOS41MTE2MzA2LDE2LjExODA3MTcgNS4yMTQwMTM2MiwxNS43MTI5ODE0IDIuNjk5NTk1NzIsMTIuODYxOTU0MSBDMC4xODUxNzc4MywxMC4wMTA5MjY5IDAuMzIwMzg0NzkzLDUuNjk2Mzc4NCAzLjAwODM4MTYsMy4wMDgzODE2IEM1LjY5NjM3ODQsMC4zMjAzODQ3OTMgMTAuMDEwOTI2OSwwLjE4NTE3NzgzIDEyLjg2MTk1NDEsMi42OTk1OTU3MiBDMTUuNzEyOTgxNCw1LjIxNDAxMzYyIDE2LjExODA3MTcsOS41MTE2MzA2IDEzLjc4NzEsMTIuNTE0NSBMMTMuNzg4LDEyLjUxNTQgWiIgaWQ9IlNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=) no-repeat center right;
  /* background-position: right 7px center; */
  height: 38px;
  width: 38px;
  display: block;
  position: absolute;
  top: 2px;
  right: 10px;
}

.debug {
  display: flex;
  flex-flow: column nowrap;
  position: fixed;
  background: rgba(4, 29, 5, 0.52);
  padding: 1em;
  bottom: 15px;
  right: 15px;

  font-size: 11px;
  border-radius: 12px;
}
.debug__item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: .5em 0;
}
.debug__key {
  padding: .25em .6em;
  background: #19bb2c;
  border-radius: 8px 0 0 8px;
  border: 1px solid #36c539;
  color: rgb(232, 255, 231);
}
.debug__value {
  padding: .25em .6em;
  background: #efefef;
  border-radius: 0 8px 8px 0;
  border: 1px solid #dddddd;
  margin-left: 2px;
}
.debug__title {
  color: #dddddd;
  font-weight: 600;
}

</style>
